export default class CopyUtils {
  static create(object: Record<string, unknown>): Record<string, unknown> {
    return { ...object }
  }
}
